<script lang="ts">
	import type {
		TrafficInformationEvent,
		TrafficInformationSummary,
	} from '$lib/components/traffic/types';
	import Icon from '$lib/components/icons/Icon.svelte';
	import ButtonMarker from '$lib/components/map/markers/ButtonMarker.svelte';
	import MarkerTemplate from '$lib/components/map/markers/markerContent/MarkerTemplate.svelte';
	import {
		mapTrafficEventTypeToScheme,
		mapTrafficSchemeToIcon,
	} from '$lib/components/traffic/constants';

	interface Props {
		trafficEvent: TrafficInformationEvent;
		selected?: boolean;
		onclick?: (trafficEvent: TrafficInformationSummary) => void;
	}

	const { trafficEvent, selected = false, onclick }: Props = $props();

	const extraClasses = $derived(selected ? 'z-infront' : '');
	const scheme = $derived(mapTrafficEventTypeToScheme[trafficEvent.type as keyof typeof mapTrafficEventTypeToScheme]);

	const coordinates = $derived(trafficEvent.coordinates);

	function handleTrafficMarkerClick() {
		if (!coordinates) {
			return;
		}

		onclick?.({
			...trafficEvent,
			coordinates,
		});
	}
</script>

{#if coordinates}
	<!-- Force the component to unmount and remount because we change the z-index on selected. Changing -->
	<!-- z-index triggers a stacking context change which then breaks the marker positioning on the map -->
	{#key selected}
		<ButtonMarker
			lngLat={[coordinates.lng, coordinates.lat]}
			markerOptions={{
				anchor: 'bottom',
				// Add an offset to the marker to account for the height of the marker arrow.
				offset: [0, -4],
			}}
			class="rd-1 hover:z-hover bg-transparent {extraClasses}"
			ariaLabel={trafficEvent.description ?? ''}
			onclick={handleTrafficMarkerClick}
		>
			<MarkerTemplate {scheme} tag="span">
				<Icon icon={mapTrafficSchemeToIcon[scheme as keyof typeof mapTrafficSchemeToIcon]} tag="span" />
			</MarkerTemplate>
		</ButtonMarker>
	{/key}
{/if}
